import { IInfiniteData } from '../../../../types';

import { IInboundListItemsData } from '../../../types';

/**
 * Format the response of the inbound list items.
 */
export function formatInboundsListResponse(
  data: IInfiniteData<IInboundListItemsData> | undefined
): IInboundListItemsData {
  if (!data?.pages) return { inbounds: [], total: 0 };

  let total = 0;
  const inbounds = data.pages.flatMap((page) => {
    total = page.total;

    return page.inbounds;
  });

  return { inbounds, total };
}
